"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.relinkBillStatus = exports.pastDueRentBillStatus = exports.zeroBalanceBillStatus = exports.balanceTooLowBillStatus = exports.balanceTooHighBillStatus = exports.selfPayPendingBillStatus = exports.selfPayDDAPendingBillStatus = exports.selfPayVCPendingBillStatus = exports.selfPayDDAIssuedBillStatus = exports.selfPayVCIssuedBillStatus = exports.selfPayDDABillStatus = exports.selfPayVCBillStatus = exports.updateCardGenericBillStatus = exports.pastDownpaymentDeadlineBillStatus = exports.updateCardInsufficientFundsBillStatus = exports.updateCardDefaultBillStatus = exports.updateCardBillStatus = exports.billStatusFactory = void 0;
var domain_1 = require("@genoa/domain");
var billStatusFactory = function (_a) {
    var header = _a.header, subheader = _a.subheader, billStatus = _a.billStatus, billStage = _a.billStage, cta = _a.cta, billAction = _a.billAction, serviceIssueCode = _a.serviceIssueCode, estimated = _a.estimated, creditLineType = _a.creditLineType, simplifiedPayments = _a.simplifiedPayments, autopayOn = _a.autopayOn, billAmount = _a.billAmount;
    return ({
        bill_info: {
            header: header || 'Your rent has been paid!',
            subheader: subheader || 'We’ll report your on-time rent payment to the credit bureaus.',
            bill_status: {
                status: billStatus || domain_1.RentPaymentStatus.RENT_PAID,
                name: 'Rent paid',
                service_issue_code: serviceIssueCode || domain_1.ServiceIssueCode.NO_ISSUE,
            },
            bill_action: {
                status: billAction || undefined,
                name: cta || '',
            },
            stage: billStage || domain_1.BillStage.SECOND_PAYMENT,
        },
        bill_info_shared: {
            cycle_date: '2024-06-01',
            bill_amount: estimated ? 0 : billAmount || 157500,
            bill_transaction_id: '12345asdfg23456sdfg',
            estimated_bill_amount: billAmount || 150000,
        },
        bill_payment_config: {
            is_autopay_on: autopayOn || true,
            is_simplified_payment: simplifiedPayments || false,
            biller_type: domain_1.BillerType.DIRECT_INTEGRATION,
            credit_line_product_type: creditLineType || domain_1.CreditLineProductType.FSLC,
        },
    });
};
exports.billStatusFactory = billStatusFactory;
exports.updateCardBillStatus = (0, exports.billStatusFactory)({
    header: 'We couldn’t find your rent bill',
    subheader: 'Reconnect your property to resume Flex service.',
    cta: 'View details',
    billAction: domain_1.BillActionStatus.VIEW_DETAILS,
    billStage: domain_1.BillStage.FIRST_PAYMENT,
    billStatus: domain_1.RentPaymentStatus.SERVICE_ISSUE,
    serviceIssueCode: domain_1.ServiceIssueCode.RETRY_OR_UPDATE_CARD,
});
exports.updateCardDefaultBillStatus = (0, exports.billStatusFactory)({
    header: 'We couldn’t find your rent bill',
    subheader: 'Reconnect your property to resume Flex service.',
    cta: 'View details',
    billAction: domain_1.BillActionStatus.VIEW_DETAILS,
    billStage: domain_1.BillStage.FIRST_PAYMENT,
    billStatus: domain_1.RentPaymentStatus.SERVICE_ISSUE,
    serviceIssueCode: domain_1.ServiceIssueCode.DEFAULT_PAYMENT_FAILURE,
});
exports.updateCardInsufficientFundsBillStatus = (0, exports.billStatusFactory)({
    header: 'We couldn’t find your rent bill',
    subheader: 'Reconnect your property to resume Flex service.',
    cta: 'View details',
    billAction: domain_1.BillActionStatus.VIEW_DETAILS,
    billStage: domain_1.BillStage.FIRST_PAYMENT,
    billStatus: domain_1.RentPaymentStatus.SERVICE_ISSUE,
    serviceIssueCode: domain_1.ServiceIssueCode.INSUFFICIENT_FUNDS,
});
exports.pastDownpaymentDeadlineBillStatus = (0, exports.billStatusFactory)({
    header: 'Payment processing',
    subheader: 'The rent payment window has closed, it may take up to 2 hours for Flex to process payments.',
    cta: '',
    billAction: undefined,
    billStage: domain_1.BillStage.FIRST_PAYMENT,
    billStatus: domain_1.RentPaymentStatus.SERVICE_ISSUE,
    serviceIssueCode: domain_1.ServiceIssueCode.PAST_DOWNPAYMENT_DEADLINE,
});
exports.updateCardGenericBillStatus = (0, exports.billStatusFactory)({
    header: 'We couldn’t find your rent bill',
    subheader: 'Reconnect your property to resume Flex service.',
    cta: 'View details',
    billAction: domain_1.BillActionStatus.VIEW_DETAILS,
    billStage: domain_1.BillStage.FIRST_PAYMENT,
    billStatus: domain_1.RentPaymentStatus.SERVICE_ISSUE,
    serviceIssueCode: domain_1.ServiceIssueCode.GENERIC_PAYMENT_FAILURE,
});
exports.selfPayVCBillStatus = (0, exports.billStatusFactory)({
    header: 'Help us complete your rent payment',
    subheader: 'Unfortunately, we couldn’t complete your rent payment. Use the provided virtual card to pay rent directly to your property.',
    cta: 'Get started',
    billAction: domain_1.BillActionStatus.VIEW_DETAILS,
    billStage: domain_1.BillStage.RENT_PAYMENT,
    billStatus: domain_1.RentPaymentStatus.SERVICE_ISSUE,
    serviceIssueCode: domain_1.ServiceIssueCode.SELF_PAY_VC,
    estimated: true,
});
exports.selfPayDDABillStatus = (0, exports.billStatusFactory)({
    header: 'Help us complete your rent payment',
    subheader: 'Unfortunately, we couldn’t complete your rent payment. Use the provided bank account to pay rent directly to your property.',
    cta: 'Get started',
    billAction: domain_1.BillActionStatus.VIEW_DETAILS,
    billStage: domain_1.BillStage.RENT_PAYMENT,
    billStatus: domain_1.RentPaymentStatus.SERVICE_ISSUE,
    serviceIssueCode: domain_1.ServiceIssueCode.SELF_PAY_DDA,
    estimated: true,
});
exports.selfPayVCIssuedBillStatus = (0, exports.billStatusFactory)({
    header: 'We’re working to confirm your payment',
    subheader: 'If you’ve self-submitted your rent payment, we’ll notify you when the payment has been processed. This may take up to 4 days.',
    cta: 'Get started',
    billAction: domain_1.BillActionStatus.VIEW_DETAILS,
    billStage: domain_1.BillStage.RENT_PAYMENT,
    billStatus: domain_1.RentPaymentStatus.SERVICE_ISSUE,
    serviceIssueCode: domain_1.ServiceIssueCode.SELF_PAY_VC_ISSUED,
});
exports.selfPayDDAIssuedBillStatus = (0, exports.billStatusFactory)({
    header: 'We’re working to confirm your payment',
    subheader: 'If you’ve self-submitted your rent payment, we’ll notify you when the payment has been processed. This may take up to 4 days.',
    cta: 'Get started',
    billAction: domain_1.BillActionStatus.VIEW_DETAILS,
    billStage: domain_1.BillStage.RENT_PAYMENT,
    billStatus: domain_1.RentPaymentStatus.SERVICE_ISSUE,
    serviceIssueCode: domain_1.ServiceIssueCode.SELF_PAY_DDA_ISSUED,
});
exports.selfPayVCPendingBillStatus = (0, exports.billStatusFactory)({
    header: 'We’re working to confirm your payment',
    subheader: 'If you’ve self-submitted your rent payment, we’ll notify you when the payment has been processed. This may take up to 4 days.',
    cta: 'Get started',
    billAction: domain_1.BillActionStatus.VIEW_DETAILS,
    billStage: domain_1.BillStage.RENT_PAYMENT,
    billStatus: domain_1.RentPaymentStatus.SERVICE_ISSUE,
    serviceIssueCode: domain_1.ServiceIssueCode.SELF_PAY_VC_PENDING_BP_WINDOW_OPEN,
});
exports.selfPayDDAPendingBillStatus = (0, exports.billStatusFactory)({
    header: 'We’re working to confirm your payment',
    subheader: 'If you’ve self-submitted your rent payment, we’ll notify you when the payment has been processed. This may take up to 4 days.',
    cta: 'Get started',
    billAction: domain_1.BillActionStatus.VIEW_DETAILS,
    billStage: domain_1.BillStage.RENT_PAYMENT,
    billStatus: domain_1.RentPaymentStatus.SERVICE_ISSUE,
    serviceIssueCode: domain_1.ServiceIssueCode.SELF_PAY_DDA_PENDING_BP_WINDOW_OPEN,
});
exports.selfPayPendingBillStatus = (0, exports.billStatusFactory)({
    header: 'We’re working to confirm your payment',
    subheader: 'If you’ve self-submitted your rent payment, we’ll notify you when the payment has been processed. This may take up to 4 days.',
    cta: 'View details',
    billAction: domain_1.BillActionStatus.VIEW_DETAILS,
    billStage: domain_1.BillStage.RENT_PAYMENT,
    billStatus: domain_1.RentPaymentStatus.SERVICE_ISSUE,
    serviceIssueCode: domain_1.ServiceIssueCode.SELF_PAY_PENDING,
});
exports.balanceTooHighBillStatus = (0, exports.billStatusFactory)({
    header: 'Your rent balance is different than estimated',
    subheader: 'Let us know how much you’d like Flex to pay your property this month.',
    cta: 'View details',
    billAction: domain_1.BillActionStatus.VIEW_DETAILS,
    billStage: domain_1.BillStage.GET_READY,
    billStatus: domain_1.RentPaymentStatus.SERVICE_ISSUE,
    serviceIssueCode: domain_1.ServiceIssueCode.BALANCE_TOO_HIGH,
});
exports.balanceTooLowBillStatus = (0, exports.billStatusFactory)({
    header: 'Your rent balance is different than estimated',
    subheader: 'Let us know how much you’d like Flex to pay your property this month.',
    cta: 'View details',
    billAction: domain_1.BillActionStatus.VIEW_DETAILS,
    billStage: domain_1.BillStage.GET_READY,
    billStatus: domain_1.RentPaymentStatus.SERVICE_ISSUE,
    serviceIssueCode: domain_1.ServiceIssueCode.BALANCE_TOO_LOW,
});
exports.zeroBalanceBillStatus = (0, exports.billStatusFactory)({
    header: 'We detected your rent bill is $0',
    subheader: 'Tell us if anything changed, like if you moved or if your property had a change in management.',
    cta: 'View details',
    billAction: domain_1.BillActionStatus.VIEW_DETAILS,
    billStage: domain_1.BillStage.GET_READY,
    billStatus: domain_1.RentPaymentStatus.SERVICE_ISSUE,
    serviceIssueCode: domain_1.ServiceIssueCode.ZERO_BALANCE,
    estimated: true,
    billAmount: 0,
});
exports.pastDueRentBillStatus = (0, exports.billStatusFactory)({
    header: 'You have an overdue rent balance',
    subheader: 'Settle the overdue balance directly with your property to resume Flex service.',
    cta: 'View details',
    billAction: domain_1.BillActionStatus.VIEW_DETAILS,
    billStage: domain_1.BillStage.GET_READY,
    billStatus: domain_1.RentPaymentStatus.SERVICE_ISSUE,
    serviceIssueCode: domain_1.ServiceIssueCode.PAST_DUE_RENT,
    estimated: true,
});
exports.relinkBillStatus = (0, exports.billStatusFactory)({
    header: 'We couldn’t find your rent bill',
    subheader: 'Reconnect your property to resume Flex service.',
    cta: 'View details',
    billAction: domain_1.BillActionStatus.VIEW_DETAILS,
    billStage: domain_1.BillStage.GET_READY,
    billStatus: domain_1.RentPaymentStatus.SERVICE_ISSUE,
    serviceIssueCode: domain_1.ServiceIssueCode.RELINK_PROPERTY,
    estimated: true,
});
